module.exports = __webpack_public_path__ + "img/118.bcdc8959.jpg";